import { render, staticRenderFns } from "./CoreSelectProduct.vue?vue&type=template&id=f5c7b382"
import script from "./CoreSelectProduct.vue?vue&type=script&lang=js"
export * from "./CoreSelectProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports